import { templateConfig } from "@/constants/templateConfig";
import { rgba } from '@/helpers/colorsUtil'
import { TEMPLATE_VERSIONS } from '../constants/versions'

export const updateTemplateHelper = (set, values) => {
    Object.keys(values).forEach(key => {
        set(key, values[key])
    })
}

export const getTemplateById = (id) => {
    return Object.values(templateConfig).flat().find(template => template.id === id)
}

export const getDefaultTemplate = (style, version) => {
    const templateId = TEMPLATE_VERSIONS()[style][version].defaultTemplate
    return getTemplateById(templateId)
}

export const updatePalette = (selectedPalette, safeSetTemplate) => {
  const {
    styles: { preColor: palette },
  } = selectedPalette

  updateTemplateHelper(safeSetTemplate, {
    'theme.palette.primary.main': rgba(palette.brand),
    'theme.palette.background.container': rgba(palette.brand),
    'theme.palette.secondary.main': rgba(palette.altBrand),
    'theme.palette.text.primary': rgba(palette.text),
    'theme.palette.text.secondary': rgba(palette.textAlt),
    'theme.palette.background.paper': rgba(palette.complementary)
  })

  /* updateTemplateHelper(safeSetTemplate, {
    'theme.palette.primary.main': rgba(palette.complementary),
    'theme.palette.background.container': rgba(palette.brand),
    'theme.palette.secondary.main': rgba(palette.textAlt),
    'theme.palette.text.primary': rgba(palette.text),
    'theme.palette.text.secondary': rgba(palette.textAlt),
    'theme.palette.background.paper': rgba(palette.complementary)
  }) */

  return palette
}

export const updateFont = (font, safeSetTemplate) => {
  updateTemplateHelper(safeSetTemplate, {
    "theme.typography.fontFamily": font.header,
    "theme.typography.secondaryFont.fontFamily": font.body,
    "theme.typography.h1.fontFamily": font.header,
    "theme.typography.h2.fontFamily": font.header,
    "theme.typography.body1.fontFamily": font.body,
    "logo.fontFamily": font.body,
  })
}

export const updateHeaderLogo = (url, safeSetTemplate) => {
  safeSetTemplate('logo.src', url ?? '')
}